// NavbarComponent.jsx
import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { AiFillDashboard } from "react-icons/ai";
import { AiOutlineSetting } from "react-icons/ai";
import { FaUserCircle } from "react-icons/fa";
import { TbLogout } from "react-icons/tb";
import { useNavigate } from 'react-router-dom';

export default function MenuComponent(){
  const navigate = useNavigate();

  return (
    <Navbar expand="md" 
      style={{ 
        backgroundColor: '#3450a3'
      }} 
      variant="dark"
    >
    <Container fluid>
      <Navbar.Brand 
        href="/dashboard/" 
        className="d-flex align-items-center text-white"
      >
        <AiFillDashboard size={30} className="me-2" />
        Audiencias
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="menu-principal" className="justify-content-end">
        <Nav>
          {/*<Nav.Link className="text-white">Tablero</Nav.Link>*/}
          <Nav.Link className="text-white"><AiOutlineSetting /></Nav.Link>
          <Nav.Link className="text-white"><FaUserCircle /></Nav.Link>
          <Nav.Link className="text-white" onClick={()=>navigate('/')}><TbLogout /></Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
  );
};